export default __webpack_public_path__ + "static/media/574.d79ca5f6.gif";